import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

function FocusActivities() {
  const [focusDataListContent, setfocusDataListContent] = useState([]);
  useEffect(() => {
    axios
      .post("/api/website/getFocusList", {})
      .then((response) => {
        console.log(response.data.data);
        setfocusDataListContent(response.data.data.focusDataList);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      });

    return () => {};
  }, []);
  return (
    <>
      <Navbar />
      <main className="pb-[166px]">
        <section className="h-[250px] m-auto pt-[90px] page-title">
          <div className="text-center mb-[44px]">
            <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">焦點活動</h2>
            <h3 className="text-[#696969] font-normal text-xl" style={{ color: "#ff6b2b" }}>
              Focus Activities
            </h3>
          </div>
        </section>
        <section className="w-[980px] m-auto pt-[70px]">
          {focusDataListContent.length !== 0 &&
            focusDataListContent.map((item, index) => (
              <div key={"list" + index}>
                <Box className="my-[10px]" display="flex" width="100%">
                  <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
                    <img
                      src={item.thumbnailUrl}
                      alt=""
                      className="border-8 border-white shadow-2xl"
                    />
                  </Box>
                  <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
                    <p
                      className="pb-[25px]"
                      style={{
                        fontSize: "30px",
                        color: "#A93230",
                        fontWeight: 400,
                      }}
                    >
                      {item.title}
                    </p>
                    <p
                      className="pb-[25px]"
                      style={{
                        fontSize: "30px",
                        color: "#A93230",
                        fontWeight: 400,
                      }}
                    >
                      {item.intro}
                    </p>
                    {item.redirectUrl != "" ? (
                      <Button
                        sx={{
                          fontSize: "20px",
                          padding: "13px 35px",
                          backgroundColor: "#FFCC06",
                          color: "black",
                          fontWeight: 400,
                          "&:hover": { backgroundColor: "darkorange" },
                        }}
                        component={Link}
                        to={item.redirectUrl}
                      >
                        查看更多
                      </Button>
                    ) : (
                      <Button
                        sx={{
                          fontSize: "20px",
                          padding: "13px 35px",
                          backgroundColor: "#FFCC06",
                          color: "black",
                          fontWeight: 400,
                          "&:hover": { backgroundColor: "darkorange" },
                        }}
                        component={Link}
                        to={"/page" + item.typeID + "?id=" + item.pageID}
                      >
                        查看更多
                      </Button>
                    )}
                  </Box>
                </Box>
                <Divider />
              </div>
            ))}
        </section>
      </main>
      <Footer />
    </>
  );
}

export default FocusActivities;
